import { readCookieRaw } from '../../utils/cookies'
import { FsCore } from '../../types/fs-core'
import { delay } from '../../utils/fetch-with-retry'

const EC_STATUS_TIME_LIMIT = 30000
const EC_STATUS_WAIT_TIME = 1000

export const eligibilityStatusWithRetry = async (brand: string, requestId: string) => {
  let totalTime = 0

  while (totalTime < EC_STATUS_TIME_LIMIT) {
    const startTime = Date.now()

    try {
      const { eligibilityStatus } = await fetchEligibilityStatus(brand, requestId)

      if (eligibilityStatus === 'ready') {
        return true
      }
    } catch (error) {
      return false
    }

    await delay(EC_STATUS_WAIT_TIME)
    totalTime += EC_STATUS_WAIT_TIME + (Date.now() - startTime)
  }

  return false
}

const fetchEligibilityStatus = async (
  brand: string,
  requestId: string,
): Promise<FsCore.EligibilityStatusResult> => {
  const OK = 200
  const response = await eligibilityStatusRequest(brand, requestId)

  if (response.status !== OK) {
    throw new Error('Error fetching eligibility status')
  }

  const eligibilityStatusResult: FsCore.EligibilityStatusResult = await response.json()

  return eligibilityStatusResult
}

const eligibilityStatusRequest = (brand: string, requestId: string) =>
  fetch(
    `${window.__FS_API_URL__}/eligibility/status?brand=${brand}&deviceId=${readCookieRaw(
      'uscd',
    )}&requestId=${requestId}`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    },
  )
